import { Languages } from '../interfaces/common'

export const REGISTRATION_PAGE_TITLE = {
  [Languages.RU]: 'Регистрация пользователей. Актион-Медиа',
  [Languages.KZ]: 'Регистрация пользователей',
  [Languages.UZ]: {
    [Languages.RU]: 'Регистрация пользователей',
    [Languages.UZ]: 'Foydalanuvchilarni roʼyxatdan oʼtkazish',
  },
}

export const REGISTRATION_PAGE_DESCRIPTION = {
  [Languages.RU]: 'Регистрация пользователей на сайте id2.action-media.ru',
  [Languages.KZ]: 'Регистрация пользователей на сайте id.mcfr.kz',
  [Languages.UZ]: 'Регистрация пользователей на сайте id.mcfr.uz',
}

export const REGISTRATION_PAGE_KEYWORDS = {
  [Languages.RU]: 'регистрация, зарегистрироваться, Актион Медиа',
  [Languages.KZ]: 'регистрация, зарегистрироваться, МЦФЭР-Казахстан',
  [Languages.UZ]: 'регистрация, зарегистрироваться, ООО «Издательский дом МЦФЭР-У»',
}
